import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Opera } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Opera>()

export function TableOpere({
  opere,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  opere: Opera[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  const numPages = useMemo(() => {
    if (!opere) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [opere, count])
  return (
    <Table
      data={opere}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="titolo"
        sortable
        width="400px"
        render={(opera) => (
          <Link to={`/opere/opere/${opera.id}/dettaglio`}>
            <LinkMagik className="text-dark">{opera.titolo}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Column
        title="Numero edizioni"
        name="numero_edizioni"
        sortable
        width="minmax(max-content, 1fr)"
        render={(opera) => opera.numero_edizioni}
      />
      <Table.Column
        title="Autore"
        name="autore__nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(opera) => opera.autore_data?.nome}
      />
      <Table.Column
        title="Bozza"
        name="bozza"
        sortable
        width="minmax(max-content, 1fr)"
        render={(opera) => (opera.bozza ? "Si" : "No")}
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} opere
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
